import { Button, Table, Tag, Modal } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import HistoricSteps from './HstoricSteps';
import { customerRoutes } from '../../utils/constants/routes';

const MissingDocuments = ({ contract, downloadFile, spinLoading }) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [documentModal, setDocumentModal] = useState();
  const navigate = useNavigate();

  const TagStatus = (status) => {
    if (status === 'DIVERS') {
      return (
        <Tag color="cyan" style={{ marginBottom: 5 }}>
          Non-obligatoire
        </Tag>
      );
    }
    if (status === 'SAVED') {
      return (
        <Tag color="cyan" style={{ marginBottom: 5 }}>
          Enregistré
        </Tag>
      );
    }
    if (status === 'SENT') {
      return (
        <Tag color="processing" style={{ marginBottom: 5 }}>
          Envoyé
        </Tag>
      );
    }
    if (status === 'VALID') {
      return (
        <Tag color="success" style={{ marginBottom: 5 }}>
          Validé
        </Tag>
      );
    }
    if (status === 'MISSING') {
      return (
        <Tag color="error" style={{ marginBottom: 5 }}>
          Manquant
        </Tag>
      );
    }
    return <div />;
  };

  const columns = [
    {
      title: t('contractDocuments.date'),
      ellipsis: true,
      render: () =>
        contract &&
        moment(contract.effective_date).format(`DD/MM/YYYY [à] HH:mm`)
    },
    {
      title: t('contractDocuments.type'),
      render: (record) => (
        <div style={{ whiteSpace: 'normal' }}>
          {t(`contractDocuments.${record.name}`)}
        </div>
      )
    },
    {
      title: t('contractDocuments.files'),
      render: (record) => {
        if (record.files.length === 0) {
          return '';
        }
        return record.files.map((file) => {
          return (
            <p>
              <Button
                style={{ marginLeft: -16, whiteSpace: 'normal' }}
                type="link"
                onClick={() => downloadFile(file)}
              >
                <UploadOutlined />
                {`${file.metadata?.originalName}`}
              </Button>
            </p>
          );
        });
      }
    },
    {
      title: t('contractDocuments.statut'),
      render: (record) => TagStatus(record.status)
    },
    {
      title: t('contractDocuments.depositDate'),
      ellipsis: true,
      render: (record) => {
        if (record.savedDate && record.history?.length)
          return moment(record.savedDate).format(`DD/MM/YYYY [à] HH:mm`);
        return '-';
      }
    },
    {
      title: t('contractDocuments.depositBy'),
      render: (record) => {
        if (record.savedBy)
          return `${record.savedBy?.first_name} ${record.savedBy?.last_name}`;
        return '-';
      }
    },
    {
      title: t('contractDocuments.historic'),
      render: (record) => {
        return (
          <Button
            loading={spinLoading}
            type="link"
            onClick={() => {
              setDocumentModal(record.history);
              setIsModalVisible(true);
            }}
          >
            {record.history?.length ? 'Consulter' : ''}
          </Button>
        );
      }
    },
    {
      title: t('contractDocuments.missingPart'),
      render: () => {
        return (
          <Button
            loading={spinLoading}
            type="link"
            onClick={() =>
              navigate(`${customerRoutes.MISSING_PARTS}/show/${contract?._id}`)
            }
          >
            Envoyer
          </Button>
        );
      }
    }
  ];

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const documentsFilter = (documents) => {
    return documents.filter((doc) => {
      return (
        doc.status === 'SENT' ||
        doc.status === 'MISSING' ||
        doc.status === 'SAVED' ||
        doc.status === 'VALID'
      );
    });
  };

  return (
    <>
      <Modal
        title="Historique"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <HistoricSteps
          documentModal={documentModal}
          downloadFile={downloadFile}
        />
      </Modal>
      <Table
        columns={columns}
        dataSource={documentsFilter(contract.documents)}
      />
    </>
  );
};

MissingDocuments.propTypes = {
  spinLoading: PropTypes.bool.isRequired,
  downloadFile: PropTypes.func.isRequired,
  contract: PropTypes.shape({
    documents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    effective_date: PropTypes.string,
    _id: PropTypes.string
  }).isRequired
};

export default MissingDocuments;
